import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastController } from '@ionic/angular';
import { BugReport } from 'src/app/models/bugReport';
import { ApiProviderService } from 'src/app/services/api-provider.service';
import { ApiProvider } from 'src/app/services/api-providers/api-provider';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
})
export class ReportComponent implements OnInit {
  bugForm: FormGroup;


  constructor(
    private fb: FormBuilder,
    private toastController: ToastController,
    private apiProvider: ApiProviderService // Assurez-vous d'importer ApiService si vous l'utilisez
  ) {
    this.bugForm = this.fb.group({
      title: ['', Validators.required],
      description: ['', [Validators.required, Validators.minLength(10)]],
      severity: [1, Validators.required]

    });
  }

  ngOnInit() { }

  async submitBugReport() {
    if (this.bugForm.invalid) {
      this.bugForm.markAllAsTouched();
      return;
    }
    const report: BugReport = {
      title: this.bugForm.value.title,
      description: this.bugForm.value.description,
      severity: this.bugForm.value.severity
    };
    try {
      this.apiProvider.request('POST', 'BugReport', report).subscribe({
        next: async () => {
          this.bugForm.reset({ severity: 3 });

          const toast = await this.toastController.create({
            message: 'Merci pour votre rapport !',
            duration: 2000,
            color: 'success'
          });
          await toast.present();
        },
        error: async (err) => {
          console.error('Erreur lors de l\'envoi du rapport :', err);

          const toast = await this.toastController.create({
            message: 'Une erreur est survenue. Veuillez réessayer.',
            duration: 2500,
            color: 'danger'
          });
          await toast.present();
        }
      });
    } catch (error) {
      console.error('Erreur inattendue :', error);

      const toast = await this.toastController.create({
        message: 'Erreur inattendue. Veuillez réessayer plus tard.',
        duration: 2500,
        color: 'danger'
      });
      await toast.present();
    }


  }

  getSeverityLabel(level: number): string {
    switch (level) {
      case 1: return 'Très faible';
      case 2: return 'Faible';
      case 3: return 'Modéré';
      case 4: return 'Élevé';
      case 5: return 'Critique';
      default: return '';
    }
  }
}


